import BgvDegreeInstituteName from './helper-text-jsx/bgv-degree-institute-name';
import NameAsPerCertificate from './helper-text-jsx/name-per-certificate';
export interface HelperTextJSXProps {
  input: {
    label: string,
    placeholder: string,
    inputType: string,
    validation: {
      fn: string,
      message: string
    },
    fieldName: string,
    disabled: boolean,
    getProfileValue: string,
    helperTextJSXKey: string
  };
  value?: string;
}

function HelperTextJSX(props: HelperTextJSXProps) {
  const { input } = props;

  let jsx = <></>;
  // FIX: Correctly access the institute name from the first field object in the fields array
  // FIX: Correct property name and remove unused variable warning
  switch (input?.helperTextJSXKey) {
    case 'nameAsPerDocument':
    case 'nameAsPerCertificate':
      jsx = <NameAsPerCertificate {...props} />;
      break;
    case 'bgv-degree:nameOfInstitute':
      jsx = <BgvDegreeInstituteName />;
      break;
    default:
      break;
  }
  return jsx;
}

export default HelperTextJSX;
